import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import theme from '../../../../../targpatrol-en/src/pages/_theme';
import Seo from '@elegantstack/solid-ui-components/src/Seo';
import Header from '@solid-ui-blocks/Header/Block01/Block01';
import Divider from '@elegantstack/solid-ui-components/src/Divider';
import Footer from '@solid-ui-blocks/Footer/Block01/Block01';
import Layout from '@elegantstack/solid-ui-layout/src/Layout';
import { normalizeBlockContentNodes } from '@blocks-helpers';
import CookieBannerEn from '../../../../../../sites/targpatrol-en/src/@elegantstack/flow-ui-widgets/CookieBanner/CookieBanner';
import CookieBannerRu from '../../../../../../sites/targpatrol-ru/src/@elegantstack/flow-ui-widgets/CookieBanner/CookieBanner';

const BasePage = (
  { title, pathname, keywords, description, children, location, lang = 'en' },
  props
) => {
  const { allBlockContent } = useStaticQuery(basePageQuery);
  const content = normalizeBlockContentNodes(allBlockContent?.nodes);

  const getContent = (block) => content[`${block}-common`];

  return (
    <Layout theme={theme} {...props}>
      <Seo
        title={title}
        keywords={keywords}
        description={description}
        pathname={pathname}
        lang={lang}
      />
      {/* Условие для рендера CookieBanner в зависимости от языка */}
      {lang === 'ru' ? <CookieBannerRu /> : <CookieBannerEn />}
      <Header />
      <Divider space={[10, null, null, null, 16]} />
      {children}
      <Footer content={getContent('footer')} />
    </Layout>
  );
};

export default BasePage;

const basePageQuery = graphql`
  query basePageQuery {
    allBlockContent(filter: { page: { in: ["shared"] } }) {
      nodes {
        ...BlockContent
      }
    }
    logo: file(
      absolutePath: { regex: "/logo.(jpeg|jpg|gif|png|svg)/" }
      sourceInstanceName: { eq: "asset" }
    ) {
      childImageSharp {
        gatsbyImageData(
          width: 170
          layout: CONSTRAINED
          quality: 100
          placeholder: NONE
        )
      }
    }
  }
`;
